const LinearLayout = ({
  orientation = "vertical",
  xgravity = "start",
  ygravity = "start",
  width = "wrap-content",
  height = "wrap-content",
  gap = 0,
  padding = 0,
  margin = 0,
  bgcolor = "",
  weights = [],
  dir = "ltr",
  className = "",
  children,
}) => {
  const dirl = orientationClass(orientation); // row یا column
  const gravityClass = gravity(xgravity, ygravity, dirl);
  const widthClass = sizeClass(width, "w");
  const heightClass = sizeClass(height, "h");
  const gapClass = `gap-${gap}`;
  const paddingClass = `p-${padding}`;
  const marginClass = `m-${margin}`;
  const bg = bgcolor ? `bg-${bgcolor}` : "";
  const inlineStyles = {};
  if (!["match-parent", "wrap-content"].includes(width)) {
    inlineStyles.width = width;
  }
  if (!["match-parent", "wrap-content"].includes(height)) {
    inlineStyles.height = height;
  }
  return (
    <div
      className={`d-flex flex-${dirl} ${gravityClass} ${widthClass} ${heightClass} ${gapClass} ${paddingClass} ${marginClass} ${bg} ${className}`}
      style={inlineStyles}
      dir={dir}
    >
      {children}
    </div>
  );
};

const orientationClass = (orient) => {
  return orient === "horizontal" ? "row" : "column";
};

const gravity = (x, y, dir) => {
  if (dir === "column") {
    return `justify-content-${y} align-items-${x}`;
  } else {
    return `justify-content-${x} align-items-${y}`;
  }
};

const sizeClass = (value, prefix) => {
  // اگر کاربر خودش یه کلاس خاص داده مثل vh-100 یا min-vh-100
  if (
    value.startsWith("vh-") ||
    value.startsWith("min-vh-") ||
    value.startsWith("max-vh-") ||
    value === "100vh"
  ) {
    return value; // مستقیم برگردونیم
  }

  switch (value) {
    case "match-parent":
      return `${prefix}-100`;
    case "wrap-content":
    default:
      return "";
  }
};

export default LinearLayout;

{
  /* <LinearLayout
  orientation="vertical"
  xgravity="center"
  ygravity="center"
  width="match-parent"
  height="match-parent"
  gap={3}
  padding={2}
  margin={0}
>
  <Spinner animation="border" variant="primary" />
  <p>Loading...</p>
</LinearLayout> */
}
// <LinearLayout
//       orientation="horizontal"
//       xgravity="center"
//       ygravity="center"
//       width="match-parent"
//       height="wrap-content"
//       gap={3}
//       padding={2}
//       margin={0}
//     >
//       <Spinner />
//     </LinearLayout>

//  <LinearLayout
//       orientation="horizontal"
//       xgravity="center"
//       ygravity="center"
//       width="match-parent"
//       height="wrap-content"
//       gap={3}
//       padding={2}
//       margin={0}
//     ></LinearLayout>
